import { IStorageAccessor, Action } from "util/domain";

export class DetailsPanelService {

    public hideDetailView:boolean = false;

    private observers:Action[] = [];

    isOpen:boolean = false;
    _isOpenInline:boolean = this.localStorageService
        .getStoredValue('sba-right-nav-inline-open') === 'true' ? true : false;

    constructor(
        private $mdMedia:ng.material.IMedia,
        private localStorageService:IStorageAccessor) {
    }

    public get isOpenInline() {
        return this._isOpenInline;
    }

    public set isOpenInline(val:boolean) {
        this._isOpenInline = val;
        this.updateInlineRightPanelState(this._isOpenInline);
    }

    public toggle() {
		if (this.$mdMedia('gt-sm')) {
            this.isOpenInline = !this.isOpenInline;
		} 
		else { 
			this.isOpen = !this.isOpen;
		}
    }

    public close() {
        this.isOpen = false;
        this.isOpenInline = false;
    }

    // used by app.ts, triggered on orientation change and resize
    public updateStateCallback() {
        if (this.isOpen && this.$mdMedia('gt-sm')) {
            //close flyout panel
            this.isOpenInline = true;
            this.isOpen = false;
        }
    }

	private updateInlineRightPanelState(isOpen) {
        this.localStorageService.setStoredValue('sba-right-nav-inline-open', isOpen);
        this.notifyObservers();
	}


    public registerObserver(callback:Action) {
        this.observers.push(callback);
    }

    private notifyObservers() {
        this.observers.forEach((callback) =>{ 
            if (angular.isFunction(callback)) {
                callback();
            }
        })
    }

}

DetailsPanelService.$inject = [
    '$mdMedia',
    'localStorageService'
];



// WEBPACK FOOTER //
// ./src/sharebase-app/services/detailsPanelService.ts